import { type BadgeProps } from "antd";
import dayjs, { type Dayjs } from "dayjs";

import { type TeamMemberStatusEnum } from "@fitness-app/data-models/entities/TeamMember";
import { SalesMeetingSaleStatus, SalesMeetingStatus } from "@fitness-app/data-models/entities/SalesMeeting";

import { SALE_STATUS_EMPTY_FILTER } from "./hooks/useSalesMeetingsQuery";

export const ORDER_OPTION_PREFIX = "order:";

// Synthetic Calendly URI prefix for meetings added by hand (sale happened
// outside Calendly). The unique index on calendlyInviteeUri drives the sync
// upsert, so real Calendly URIs (https://api.calendly.com/...) never collide
// with these rows and the sync leaves them untouched.
export const MANUAL_MEETING_URI_PREFIX = "manual:";

export const FILTER_DATE_FORMAT = "YYYY-MM-DD";

// The product sales calls are scored on: "Wygrane rozmowy" count only its
// sales, bikini and other products sold on a call don't (TRE-2492).
export const PROGRAM_HOLLYWOOD_PRODUCT_ID = "prod_lR6lLaCxqDqOWn";

export const statusColor: Record<SalesMeetingStatus, string> = {
  [SalesMeetingStatus.Scheduled]: "blue",
  [SalesMeetingStatus.Attended]: "green",
  [SalesMeetingStatus.NoShow]: "red",
  [SalesMeetingStatus.Canceled]: "default",
  [SalesMeetingStatus.Rescheduled]: "orange",
};

export const meetingStatusLabels: Record<SalesMeetingStatus, string> = {
  [SalesMeetingStatus.Scheduled]: "Zaplanowane",
  [SalesMeetingStatus.Attended]: "Odbyte",
  [SalesMeetingStatus.NoShow]: "Nie pojawiła się",
  [SalesMeetingStatus.Canceled]: "Odwołane",
  [SalesMeetingStatus.Rescheduled]: "Przełożone",
};

export const saleStatusLabels: Record<SalesMeetingSaleStatus, string> = {
  [SalesMeetingSaleStatus.Yes]: "Tak",
  [SalesMeetingSaleStatus.No]: "Nie",
  [SalesMeetingSaleStatus.Waiting]: "Czekam",
  [SalesMeetingSaleStatus.NotQualified]: "Nie kwalifikuje się",
};

export const teamMemberBadgeStatus = {
  PENDING: "processing",
  ACTIVE: "success",
  INACTIVE: "error",
  INVITED: "warning",
  DELETED: "default",
} as const satisfies Record<TeamMemberStatusEnum, BadgeProps["status"]>;

export const saleStatusOptions = Object.values(SalesMeetingSaleStatus).map((value) => ({
  value,
  label: saleStatusLabels[value],
}));

export const saleStatusTableFilters = [
  ...Object.values(SalesMeetingSaleStatus).map((value) => ({
    text: saleStatusLabels[value],
    value,
  })),
  {
    text: "Brak statusu",
    value: SALE_STATUS_EMPTY_FILTER,
  },
];

export const getRangePresets = (): { label: string; value: [Dayjs, Dayjs] }[] => [
  { label: "Dziś", value: [dayjs(), dayjs()] },
  { label: "Ten tydzień", value: [dayjs().startOf("week"), dayjs()] },
  { label: "Ten miesiąc", value: [dayjs().startOf("month"), dayjs()] },
  {
    label: "Poprzedni miesiąc",
    value: [dayjs().subtract(1, "month").startOf("month"), dayjs().subtract(1, "month").endOf("month")],
  },
  { label: "Ostatnie 30 dni", value: [dayjs().subtract(30, "day"), dayjs()] },
];

export const dateModeOptions = [
  { label: "Data spotkania", value: "meeting" },
  { label: "Data sprzedaży", value: "sale" },
];
